import { ChangeEvent, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useParceiro } from "../GestaoParceirosPage/hooks/useParceiro";
import { useCollaboratorSave } from "./hooks/useCollaboratorSave";

import Alert from '@mui/material/Alert';
import {
  CircularProgress,
  Typography,
  Button,
  TextField,
  Card,
  CardContent,
} from "@mui/material";

import CardLayout from "components/atoms/CardLayout/CardLayout";
import SearchSelect from "../../atoms/SearchSelect/SearchSelect";
import TelefoneField from "../../atoms/TelefoneField/TelefoneField";
import CpfField from "../../atoms/CpfField/CpfField";
import EmailAutocomplete from "../../atoms/EmailAutocomplete/EmailAutoComplete";
import PasswordField from "../../atoms/PasswordField/PasswordField";

/* Styles */
import styles from './GestaoColaboradores.module.css';
import styles_filter from "../../../styles/Filter.module.css";
import styles_input from "../../../styles/Input.module.css";
import styles_table from "../../../styles/Table.module.css";
import styles_button from "../../../styles/Button.module.css";
import styles_general from "../../../styles/General.module.css";

const NewColaborador = () => {

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const collaboratorId = searchParams.get("id");
  const [newPassword, setNewPassword] = useState<boolean>(false);

  const {  
    msgError,
    msgSuccess,
    errors,
    isEdit,
    loading,
    loadingSave,
    colaborador,
    handleNameChange,
    handleInputChange,
    handleChange,
    handleEmailChange,
    saveColaborador,
  } = useCollaboratorSave(collaboratorId);

  const { parceirosResumo } = useParceiro();

  const cancelNewPassword = () => {
    setNewPassword(false);
    handleInputChange("", "password");
    handleInputChange("", "password_confirmation");
  };

  if (loading) {
    return (
      <div className={styles["loading-container"]}>
        <CircularProgress />
        <Typography>Carregando...</Typography>
      </div>
    );
  }

  return (
    <Card className={styles.card}>
      <CardContent>
        <div className={styles.title}>
          Cadastrar Colaborador Eventual/Parceiro
        </div>
        {msgSuccess && (
          <div className={styles_table.message}>
            <Alert severity="success">
              {msgSuccess}
            </Alert>
          </div>
        )}
        {msgError && (
          <div className={styles_table.message}>
            <Alert severity="error">
              {msgError}
            </Alert>
          </div>
        )}

        <div className={styles.marginTopMd}>
          <CardLayout title="Dados do Colaborador">
            <div className={`${styles_filter.grid12} ${styles_general.p4}`}>
              <div className={styles_filter.inputGroup6}>
                <label className={styles_input.titleInput}>
                  Nome da Colaborador *
                </label>
                <TextField
                  size="small"
                  placeholder=""
                  variant="standard"
                  autoFocus={false}
                  fullWidth
                  data-testid="nome"
                  value={colaborador.nome}
                  onChange={handleNameChange}
                  required
                  inputProps={{ maxLength: 150 }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    className: styles_input.input,
                    disableUnderline: true,
                  }}
                  error={!!errors.nome}
                  helperText={errors.nome}
                />
              </div>

              <div className={styles_filter.inputGroup6}>
                <label className={styles_input.titleInput}>
                  Instituição Vinculada *
                </label>
                <SearchSelect
                  label=""
                  key="institution_id"
                  options={parceirosResumo}
                  value={colaborador.institution_id}
                  onChange={(id) => {handleChange("institution_id", id);}}
                  error={!!errors.institution_id}
                  helperText={errors.institution_id}
                  paperClassname={styles_input.paper}
                  popperClassname={styles_input.popper}
                  labelClassname={styles_input.labelSelect}
                  inputClassname={styles_input.inputSelect}
                />
              </div>

              <div className={styles_filter.inputGroup4}>
                <label className={styles_input.titleInput}>
                  Celular *
                </label>
                <TelefoneField
                  label=""
                  customClass={styles_input.input}
                  fullWidth
                  value={colaborador.celular || ""}
                  onChange={(value) => handleInputChange(value, 'celular')}
                  error={!!errors.celular}
                  helperText={errors.celular}
                />
              </div>

              <div className={styles_filter.inputGroup4}>
                <label className={styles_input.titleInput}>
                  Telefone
                </label>
                <TelefoneField
                  label=""
                  customClass={styles_input.input}
                  fullWidth
                  value={colaborador.telefone || ""}
                  onChange={(value) => handleInputChange(value, 'telefone')}
                />
              </div>

              <div className={styles_filter.inputGroup4}>
                <label className={styles_input.titleInput}>
                  Cargo/Função *
                </label>
                <TextField
                  size="small"
                  placeholder=""
                  variant="standard"
                  autoFocus={false}
                  fullWidth
                  data-testid="nome"
                  value={colaborador.cargo}
                  onChange={(e: ChangeEvent<HTMLInputElement>) => 
                    handleInputChange(e.target.value, 'cargo')
                  }
                  required
                  inputProps={{ maxLength: 150 }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    className: styles_input.input,
                    disableUnderline: true,
                  }}
                  error={!!errors.cargo}
                  helperText={errors.cargo}
                />
              </div>
            </div>
          </CardLayout>
        </div>

        <div className={`${styles.marginTopMd}`}>
          <CardLayout title="Dados para Login">
            <div className={`${styles_filter.grid12} ${styles_general.p4}`}>
              <div className={styles_filter.inputGroup4}>
                <label className={styles_input.titleInput}>
                  CPF *
                </label>
                <CpfField
                  size="small"
                  placeholder=""
                  variant="standard"
                  autoFocus={false}
                  value={colaborador.cpf}
                  onUpdate={(value) => handleInputChange(value, 'cpf')}
                  customClassName={styles_input.input}
                  error={!!errors.cpf}
                  helperText={errors.cpf}
                />
              </div>
              <div className={styles_filter.inputGroup4}>
                <label className={styles_input.titleInput}>
                  E-mail *
                </label>
                <EmailAutocomplete
                  label=""
                  value={colaborador.email}
                  onChange={(value) => handleEmailChange(value, 'email')}
                  inputProps={{disabledUnderline:true}}
                  customClassName={styles_input.input}
                  error={!!errors.email}
                  helperText={errors.email}
                />
              </div>
              <div className={styles_filter.inputGroup4}>
                <label className={styles_input.titleInput}>
                  Confirmar E-mail *
                </label>
                <EmailAutocomplete
                  label=""
                  value={colaborador.email_confirmation}
                  onChange={(value) => handleEmailChange(value, 'email_confirmation')}
                  inputProps={{disabledUnderline:true}}
                  customClassName={styles_input.input}
                  error={!!errors.email_confirmation}
                  helperText={errors.email_confirmation}
                />
              </div>

              {(!isEdit || newPassword) && (
                <>
                  <div className={styles_filter.inputGroup6}>
                    <label className={styles_input.titleInput2}>
                      Senha *
                    </label>
                    <PasswordField
                      testeid="senha"
                      fullWidth
                      label=""
                      isLogin={false}
                      value={colaborador.password}
                      onChange={(e: ChangeEvent<HTMLInputElement>) => 
                        handleInputChange(e.target.value, 'password')
                      }
                      margin="normal"
                      variant="standard"
                      customClassName={styles_input.input}
                      error={!!errors.password}
                      helperText={errors.password}
                    />
                  </div>
                  <div className={styles_filter.inputGroup6}>
                    <label className={styles_input.titleInput2}>
                      Confirmar Senha *
                    </label>
                    <PasswordField
                      testeid="senha"
                      fullWidth
                      label=""
                      isLogin={false}
                      value={colaborador.password_confirmation}
                      onChange={(e: ChangeEvent<HTMLInputElement>) => 
                        handleInputChange(e.target.value, 'password_confirmation')
                      }
                      margin="normal"
                      variant="standard"
                      customClassName={styles_input.input}
                      error={!!errors.password_confirmation}
                      helperText={errors.password_confirmation}
                    />
                  </div>
                </>
              )}

              {isEdit && !newPassword && (
                <div className={styles_filter.inputGroupfull}>
                  <Button
                    variant="contained"
                    className={styles_button.buttonSecondary}
                    onClick={() => setNewPassword(true)}
                    disabled={loadingSave}
                  >
                    Alterar Senha
                  </Button>
                </div>
              )}

              {isEdit && newPassword && (
                <div className={styles_filter.inputGroupFull}>
                  <Button
                    variant="contained"
                    className={styles_button.buttonDanger}
                    onClick={cancelNewPassword}
                    disabled={loadingSave}
                  >
                    Cancelar Alteração Senha
                  </Button>
                </div>
              )}

            </div>
          </CardLayout>
        </div>

        <div className={styles.marginTopMd}>

          <div className={styles_filter.lineButton}>
            {/* Limpar */}
            <Button 
              variant="contained"
              onClick={() => navigate(`/colaboradores`)} 
              className={styles_filter.buttonClean}
              color="primary"
            >
              Voltar
            </Button>
            
            {/* Pesquisar */}
            <Button
              variant="contained"
              onClick={saveColaborador}
              className={`${styles_filter.buttonSearch} ${(loadingSave) ? styles_button.buttonLoad : ''} `}
              color="primary"
            >
              {loadingSave ? (
                <>
                <div className={styles_button.spinner}></div>
                <span>Salvando...</span>
                </>
              ) : (
              <span>Salvar</span>
              )}
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default NewColaborador;
